import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  width: 100%;
`;
export const useStyles = makeStyles(() => ({
  delete: {
    color: theme.status.error,
  },
}));
